import { createContext, useContext } from 'react';
export const ThemingContext = createContext({
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    setSettingsTheme(theme) { },
    useSettingsTheme() {
        return 'light';
    },
    useAppliedTheme() {
        return 'light';
    },
});
export function useAppliedTheme() {
    return useContext(ThemingContext).useAppliedTheme();
}
export function useThemeSettings() {
    const { useSettingsTheme, setSettingsTheme } = useContext(ThemingContext);
    return [useSettingsTheme(), setSettingsTheme];
}
export const themes = ['dark', 'light', 'system'];
//# sourceMappingURL=theming.js.map